<script setup>
import { computed } from 'vue';

const props = defineProps({
  boards: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const selected = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', Number(value)),
});
</script>

<template>
  <select
    v-model="selected"
    class="px-3 py-1.5 text-sm font-medium rounded-lg border border-n-weak bg-n-solid-1 text-n-slate-12 focus:outline-none focus:border-n-brand"
  >
    <option v-for="board in boards" :key="board.id" :value="board.id">
      {{ board.name }}
    </option>
  </select>
</template>
